module.exports = __webpack_public_path__ + "assets/img/购买中.e7668552.svg";